import { selectAuthSession } from '../../../../auth/store/selectors';
import {
  selectArchivedCourses,
  selectOngoingCourses,
  selectPastCourses,
} from '../../../../db/courses/selectors';
import { selectHomeActiveTab } from '../../../../home/store/selectors';
import { useAppSelector } from '../../../../store/hooks';

const useMessage = () => {
  const session = useAppSelector((state) => selectAuthSession(state));
  const canCreateCourses = session?.canCreateCourses;

  const activeTab = useAppSelector((state) => selectHomeActiveTab(state));
  const ongoingCourses = useAppSelector((state) => selectOngoingCourses(state));
  const pastCourses = useAppSelector((state) => selectPastCourses(state));
  const archivedCourses = useAppSelector((state) => selectArchivedCourses(state));

  return {
    canCreateCourses,
    activeTab,
    hasOngoingCourses: ongoingCourses.length > 0,
    hasPastCourses: pastCourses.length > 0,
    hasArchivedCourses: archivedCourses.length > 0,
  };
};

export default useMessage;
